/* src/app/modules/dna-syngovia/components/dna-syngovia-chart-map/dna-syngovia-chart-map.component.scss */
:host {
  display: block;
}
.line {
  fill: none;
  stroke-width: 2;
  stroke: var(--support-5-tint, #6CAEFF);
}
.line--client {
  stroke: rgb(0, 0, 0, var(--opacity-6));
}
/*# sourceMappingURL=dna-syngovia-chart-map.component.css.map */
